import axios from "axios";
import config from "../../config";
import {
  AuditRowQueryParams,
  AuditRowsGroupedResult,
  AuditTypesResponse,
} from "./audit-types";

const apiUrl = config.api;

export const getAuditTypes = async (): Promise<AuditTypesResponse> => {
  const response = await axios.get<AuditTypesResponse>(`${apiUrl}/audit/types`);
  return response.data;
};

export const buildAuditRowsQueryParams = (
  params: AuditRowQueryParams,
): Record<string, string> => {
  const queryParams: Record<string, string> = {
    skip: String(params.skip),
    take: String(params.take),
  };

  if (params.database) queryParams.databases = params.database;
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.sortColumn) queryParams.sortColumn = params.sortColumn;
  if (params.sortDescending) queryParams.sortDescending = "true";
  if (params.includeSensitive) queryParams.includeSensitive = "true";

  Object.entries(params.filters).forEach(([key, value]) => {
    if (value) queryParams[key] = value;
  });

  return queryParams;
};

export const getAuditRows = async (
  params: AuditRowQueryParams,
): Promise<AuditRowsGroupedResult> => {
  const response = await axios.get<AuditRowsGroupedResult>(
    `${apiUrl}/audit/${params.typeKey}/rows`,
    { params: buildAuditRowsQueryParams(params) },
  );
  return response.data;
};
